(function StartBooking($, HE)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		HE.onload('Reservations/modify', function onload()
		{
			$('#booking-conditions-link').click(function _showBookingConditions() {
				// grab the reservation_id, rate key and room code from the hidden fields
				var reservation_id = $('#hotelmodification-reservation-id').val(),
					rate_key       = $('#hotelmodification-rate_key').val(),
					room_code      = $('#hotelmodification-room_code').val(),
					check_in       = $('#hotelmodification-check_in').val(),
					check_out      = $('#hotelmodification-check_out').val();

				$('#bookingConditionsContent').html('<i class="fas fa-spinner fa-spin me-2"></i> Loading Booking Conditions...');
				$('#bookingConditions').offcanvas('show');

				HE.Ajax.get(
					'/Reservations/modificationBookingConditions/' + reservation_id + '/' + rate_key + '/' + room_code + '/' + check_in + '/' + check_out)
					.then(function _success(response) {
						// show the booking conditions in an offcanvas
						$('#bookingConditionsContent').html(response);
					});
			});

			$('#cancel-agree,#agree').click(function _enableSubmit() {
				if ($('#cancel-agree').prop('checked') === true && $('#agree').prop('checked') === true) {
					$('.submit-booking').removeClass('disabled');
					$('.submit-booking').prop('disabled', null);
				} else {
					$('.submit-booking').addClass('disabled');
					$('.submit-booking').prop('disabled', true);
				}
			});

			$('#payment-info-container').hide();
			$('#booking-conditions-container').hide();
			$('#cancellation-policies-container').hide();
			$('.submit-booking').removeClass('disabled');
			$('.submit-booking').prop('disabled', null);

			$('#modify-stay-details').click(function _modifyStayDetails() {
				var reservation_id = $(this).data('reservation-id');

				$('#signatureClientLabel').html('Modify the room rate or dates of the stay');
				$('#signatureClientContent').html('<i class="fas fa-spinner fa-spin me-2"></i> Loading Room Rates...');
				$('#signatureClient').offcanvas('show');

				_loadRoomRates({reservation_id: reservation_id});
			});

			$('.signature-client-search').click(function _searchClients() {
				var pax_idx   = $(this).data('pax-idx'),
					guest_num = (Number(pax_idx)+1);

				HE.Ajax.get('/Hotels/signatureClientLookUp/' + pax_idx).then(function _success(response) {
					$('#signatureClientLabel').html('Look Up an Existing Client for Guest #' + guest_num);
					$('#signatureClientContent').html(response);

					HE.Form.initAjaxForm('SignatureClientLookup');

					$('#signatureClient').offcanvas('show');

					$('.signature-client-lookup').click(function onSearchClick(e) {
						var form_id           = 'signatureclientlookup-',
							$first_name_input = $('#' + form_id + 'first_name'),
							$last_name_input  = $('#' + form_id + 'last_name'),
							$email_input      = $('#' + form_id + 'email'),
							first_name        = $first_name_input.val(),
							last_name         = $last_name_input.val(),
							email             = $email_input.val(),
							post_data         = {
								first_name: first_name,
								last_name : last_name,
								email     : email
							};

						e.preventDefault();

						$('.signature-client-search-results').html('<i class="fas fa-spinner fa-spin me-2"></i> Searching for client...');

						HE.Ajax.post('/Hotels/signatureClientSearch/', post_data).then(function _success(response) {
							var content = 'No results found based on criteria entered';

							// form validation handling
							if (response.error) {
								HE.Form.throwSubmissionError(_getValidationErrorMessage(response.error));
								return;
							}

							if (response !== '') {
								content = response;
							}

							$('.signature-client-search-results').html(content);

							$('.signature-client-row').click(function handleClick() {
								var return_data = {
										pax_idx            : pax_idx,
										signature_client_id: $(this).data('signature-client-id'),
										first_name         : $(this).data('first-name'),
										last_name          : $(this).data('last-name'),
										email              : $(this).data('email'),
										phone              : $(this).data('phone')
									};

								_setSignatureClientId(return_data);
								_showDifferences();
							});
						});
					});
				});
			});

			function updateResultCount() {
				var visibleCount = $('li.table-row:not(.d-none)').length;
				var searchTerm;
	
				$('.result-count').text('(' + visibleCount + ')');
	
				// Remove existing alert if it exists
				$('#no-results-alert').remove();
	
				if (visibleCount === 0) {
					searchTerm = $('#specialty-search').val();
					// Add bootstrap alert for no results, including the search term in bold
					$('<div id="no-results-alert" class="alert alert-info mt-3" role="alert">'
					  + 'No results found for your search: <strong>' + searchTerm + '</strong>'
					  + '</div>').insertAfter('ul.table');
				}
			}

			function _showDifferences() {
				var differences = [];
				var table       = '';

				if ($('#check-in').length === 0) {
					return;
				}

				if ($('#check-in').data('check-in') !== $('#hotelmodification-existing_check_in').val()) {
					differences.push({
						field: 'Check In',
						old  : $('#hotelmodification-existing_check_in').val(),
						new  : $('#check-in').data('check-in')
					});
				}

				if ($('#check-out').data('check-out') !== $('#hotelmodification-existing_check_out').val()) {
					differences.push({
						field: 'Check Out',
						old  : $('#hotelmodification-existing_check_out').val(),
						new  : $('#check-out').data('check-out')
					});
				}

				if ($('#hotelmodification-room_code').val() !== $('#hotelmodification-existing_room_code').val()) {
					differences.push({
						field: 'Rate Code',
						old  : $('#hotelmodification-existing_room_code').val(),
						new  : $('#hotelmodification-room_code').val()
					});
				}

				if ($('#hotelmodification-pax-0-first_name').val() !== $('#hotelmodification-existing_first_name').val()) {
					differences.push({
						field: 'First Name',
						old  : $('#hotelmodification-existing_first_name').val(),
						new  : $('#hotelmodification-pax-0-first_name').val()
					});
				}

				if ($('#hotelmodification-pax-0-last_name').val() !== $('#hotelmodification-existing_last_name').val()) {
					differences.push({
						field: 'Last Name',
						old  : $('#hotelmodification-existing_last_name').val(),
						new  : $('#hotelmodification-pax-0-last_name').val()
					});
				}

				if ($('#selling-price').data('selling-price') !== $('#hotelmodification-existing_total').val()) {
					differences.push({
						field: 'Total Price',
						old  : $('#hotelmodification-existing_total').val(),
						new  : $('#selling-price').data('selling-price')
					});
				}

				// if there are any differences, create a table with a column for field and a second column with old -> new	
				if (differences.length > 0) {
					table = '<table class="table table-bordered"><thead><tr class="bg-light"><td>Differences</td><td class="text-end"><small>' + differences.length + ' New</small></td></tr></thead><tbody>';

					$.each(differences, function _eachDifference(i, diff) {
						table += '<tr><td><small>' + diff.field + '</small></td><td class="text-end"><small>' + diff.old + ' <i class="heicon-arrow_right fas fa-fw fa-arrow-right"></i> ' + diff.new + '</small></td></tr>';
					});

					table += '</tbody></table>';

					$('#differences').html(table);
					$('#differences').show();
				} else {
					$('#differences').html('');
					$('#differences').hide();
				}
			}

			function _setSignatureClientId(data) {
				var pax_idx             = data.pax_idx,
					signature_client_id = data.signature_client_id,
					first_name          = data.first_name,
					last_name           = data.last_name,
					email               = data.email,
					phone               = data.phone;

				// set hidden field to signature client id
				$('#hotelmodification-pax-' + pax_idx + '-signature_client_id').val(signature_client_id);

				// set other fields
				$('#hotelmodification-pax-' + pax_idx + '-first_name').val(first_name);
				$('#hotelmodification-pax-' + pax_idx + '-last_name').val(last_name);
				$('#hotelmodification-pax-' + pax_idx + '-email').val(email);
				$('#hotelmodification-pax-' + pax_idx + '-phone').val(phone);

				// set to readonly if value returned
				if (first_name !== '') {
					$('#hotelmodification-pax-' + pax_idx + '-first_name').prop('readonly', true);
				}

				if (last_name !== '') {
					$('#hotelmodification-pax-' + pax_idx + '-last_name').prop('readonly', true);
				}

				if (email !== '') {
					$('#hotelmodification-pax-' + pax_idx + '-email').prop('readonly', true);
				}

				if (phone !== '') {
					$('#hotelmodification-pax-' + pax_idx + '-phone').prop('readonly', true);
				}

				// toggle search/clear buttons
				$('.signature-client-search[data-pax-idx="' + pax_idx + '"]').addClass('d-none');
				$('.signature-clear-search[data-pax-idx="' + pax_idx + '"]').removeClass('d-none');

				$('#signatureClient').offcanvas('hide');
			}

			function _getValidationErrorMessage(errors)
			{
				var error_string = '';

				if (typeof errors === 'string') {
					return HE.Form.buildProcessingError(errors);
				}

				error_string += '<ul>';

				$.each(errors, function onEachErrorMsg(i, field_info) {
					if (field_info.error) {
						error_string += '<li>' + field_info.error + '</li>';
					}
				});

				error_string += '</ul>';

				return error_string;
			}

			function _loadRoomRates(data)
			{
				var url = '/Reservations/modifyStayDetails/' + data.reservation_id;
				
				// if check_in and check_out are set, append to url
				if (data.check_in && data.check_out) {
					url += '/' + data.check_in + '/' + data.check_out;
				}

				if (data.sort) {
					url += '/' + data.sort;
				}
		
				HE.Ajax.get(url).then(function _success(response) {
					$('#signatureClientContent').html(response);

					HE.Form.initAjaxForm('ModifyBookingDates');

					// User selected a sort order, fetch the rates again this time sorted
					$('.rate-sort').on('click', function _sortRates(e) {
						var sort = $(this).data('sort-by');
						var reservation_id = $('#modifybookingdates-reservation_id').val(),
							check_in       = $('#modifybookingdates-check_in').val(),
							check_out      = $('#modifybookingdates-check_out').val();
		
						var data = {
							reservation_id: reservation_id,
							check_in      : check_in,
							check_out     : check_out,
							sort          : sort
						};

						e.preventDefault();
		
						$('#signatureClientContent').html('<i class="fas fa-spinner fa-spin me-2"></i> Loading Room Rates...');
		
						_loadRoomRates(data);
					});

					$('#modify-dates-button').click(function _update(event) {
						// call /Reservations/modifyStayDetails/ again but with date GET params
						var reservation_id = $('#modifybookingdates-reservation_id').val(),
							check_in       = $('#modifybookingdates-check_in').val(),
							check_out      = $('#modifybookingdates-check_out').val();
		
						var data = {
							reservation_id: reservation_id,
							check_in      : check_in,
							check_out     : check_out
						};
		
						$('#signatureClientContent').html('<i class="fas fa-spinner fa-spin me-2"></i> Loading Room Rates...');
		
						_loadRoomRates(data);
						
					});

					$('.thingy').on('click', function _toggleThingy(e) {
						var rate_key = $(this).data('rate-key');

						e.preventDefault();

						$('#modify-ratedetails-body').html('<div class="text-center"><i class="fa fa-spinner fa-spin fa-3x"></i> Loading rate details...</div>');
						$('#room-rates').hide();
						$('#modify-ratedetails').show();

						HE.Ajax.get('/Hotels/specialtyRateDetails/' + rate_key)
						.then(function _showRates(data) {

							$('#modify-ratedetails-body').html(data);
						});
					});

					$('.back-to-rates').on('click', function _backToRates(e) {
						e.preventDefault();

						$('#modify-ratedetails-body').html('');

						$('#modify-ratedetails').hide();
						$('#room-rates').show();
					});

					$('.select-rate').click(function _selectRate(event) {
						// make a POST request to setModifyStayDetails with rate, check_in, check_out
						var reservation_id = $('#modifybookingdates-reservation_id').val(),
						    rate_key       = $(this).data('rate-key'),
							room_code       = $(this).data('room-code'),
						    refundable     = $(this).data('refundable'),
						    check_in       = $('#modifybookingdates-check_in').val(),
						    check_out      = $('#modifybookingdates-check_out').val();

						var data = {
							reservation_id: reservation_id,
							rate_key      : rate_key,
							check_in      : check_in,
							check_out     : check_out,
							refundable    : refundable
						};

						event.preventDefault();

						$('#room-rates').html('<div class="text-center"><i class="fa fa-spinner fa-spin fa-3x"></i> Updating Booking Details...</div>');

						HE.Ajax.post('/Reservations/setModifyStayDetails/', data).then(function _success(response) {
							$('#modify-stay-details-info').html(response);
							$('#payment-info-container').show();
							$('#cancellation-policies-container').show();
							$('#booking-conditions-container').show();
							$('#hotelmodification-room_code').val(room_code);
							$('#hotelmodification-rate_key').val(rate_key);
							$('#hotelmodification-check_in').val(check_in);
							$('#hotelmodification-check_out').val(check_out);
							$('#signatureClient').offcanvas('hide');

							if ($('#cancel-agree').prop('checked') === true && $('#agree').prop('checked') === true) {
								$('.submit-booking').removeClass('disabled');
								$('.submit-booking').prop('disabled', null);
							} else {
								$('.submit-booking').addClass('disabled');
								$('.submit-booking').prop('disabled', true);
							}
			
							_showDifferences();
						});

					});

					$('#specialty-search').on('keyup', function _searchSpecialtyRates() {
						var str_length      = $(this).val().length,
							keywordsToIgnore = ['additional', 'room'], // Array of keywords to ignore
							str_value        = $(this).val(),
							contents,
							room_code,
							regex;
		
						var shouldSearch = str_length >= 3 && !keywordsToIgnore.includes(str_value);
		
						if (shouldSearch) {
							// Existing specialty description search
							$('.specialty-description').each(function _searchSpecialtyRatesEach() {
								room_code = $(this).data('room-code');
								contents  = $(this).data('contents');
								regex     = new RegExp('('+str_value+')', 'gi');
		
								contents = contents.replace(regex, '<span class="bg-warning">$1</span>');
								$(this).html(contents);
		
								if (contents.toLowerCase().indexOf(str_value.toLowerCase()) === -1) {
									$('li[data-room-code="' + room_code + '"]').addClass('d-none');
								}
		
								$('.btn-clear').css('visibility', 'visible');
							});
		
							// New rate name search
							$('.rate-name').each(function _searchRateNames() {
								var $this = $(this);
								var rateName = $this.data('name');
								regex = new RegExp('(' + str_value + ')', 'gi');
		
								if (rateName && rateName.toLowerCase().indexOf(str_value.toLowerCase()) !== -1) {
									// Highlight matching text in rate name
									$this.html(rateName.replace(regex, '<span class="bg-warning">$1</span>'));
									$this.closest('li').removeClass('d-none');
								} else {
									// Remove highlighting if no match
									$this.html(rateName);
									// Only hide if specialty description is also not matching
									if ($this.closest('li').find('.specialty-description').text().toLowerCase().indexOf(str_value.toLowerCase()) === -1) {
										$this.closest('li').addClass('d-none');
									}
								}
							});
		
							$('.btn-clear').css('visibility', 'visible');
						} else {
							$('li.table-row').removeClass('d-none');
							$('.btn-clear').css('visibility', 'hidden');
							$('.specialty-description span, .rate-name span').removeClass('bg-warning');
							// Restore original rate names
							$('.rate-name').each(function _restoreRateNames() {
								$(this).html($(this).data('name'));
							});
						}
		
						updateResultCount();
					});

					$('.btn-clear').on('click', function _clearSpecialtySearch() {
						$('#specialty-search').val('');
						$('li.table-row').removeClass('d-none');
						$('.specialty-description span, .rate-name span').removeClass('bg-warning');
						// Restore original rate names
						$('.rate-name').each(function _restoreRateNames() {
							$(this).html($(this).data('name'));
						});
						$(this).css('visibility', 'hidden');
		
						updateResultCount();
					});
				});
			}
		});
	});
}(jQuery, window.HE || {}));